import { Component, OnInit } from '@angular/core';
import { NotificationsCenterService } from '@core/services/notifications-center.service';
import { UserNotificationItem } from '@shared/models';
import { Observable } from 'rxjs';

@Component({
  selector: 'gcc-urgent-alerts',
  templateUrl: './urgent-alerts.component.html',
  styleUrls: ['./urgent-alerts.component.scss']
})
export class UrgentAlertsComponent implements OnInit {
  public notifications$: Observable<UserNotificationItem[]>;

  constructor(private notificationsCenter: NotificationsCenterService) {}

  public ngOnInit(): void {
    this.notifications$ = this.notificationsCenter.urgentAlerts$;
  }

  public handleDelete(id: string) {
    this.notificationsCenter.dismissPushBulk([id]);
  }
}
